module.exports = __webpack_public_path__ + "create/static/media/top_banner.b556b6b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/CreateExperience/Institucional/top_banner.jpg
// module id = 480
// module chunks = 39